import React from "react";
import { Check, Circle, AlertCircle } from "lucide-react";
import { cn } from "../../lib/utils";

export function WizardSteps({ steps, currentStep, className }) {
  return (
    <div className={cn("flex items-center justify-between", className)}>
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;
        const isError = step.error;

        return (
          <React.Fragment key={step.id || index}>
            <div className="flex flex-col items-center">
              <div
                className={cn(
                  "w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all",
                  isCompleted && "bg-green-500 border-green-500 text-white",
                  isCurrent && !isError && "border-blue-500 bg-blue-50 text-blue-600",
                  isCurrent && isError && "border-red-500 bg-red-50 text-red-600",
                  !isCompleted && !isCurrent && "border-gray-300 text-gray-400"
                )}
              >
                {isCompleted ? (
                  <Check className="w-5 h-5" />
                ) : isError ? (
                  <AlertCircle className="w-5 h-5" />
                ) : (
                  <span className="text-sm font-medium">{index + 1}</span>
                )}
              </div>
              <span
                className={cn(
                  "mt-2 text-xs font-medium text-center max-w-[80px]",
                  isCompleted && "text-green-600",
                  isCurrent && !isError && "text-blue-600",
                  isCurrent && isError && "text-red-600",
                  !isCompleted && !isCurrent && "text-gray-400"
                )}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={cn(
                  "flex-1 h-0.5 mx-2",
                  index < currentStep ? "bg-green-500" : "bg-gray-200"
                )}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export function WizardContent({ children, className }) {
  return (
    <div className={cn("mt-8 min-h-[300px]", className)}>
      {children}
    </div>
  );
}
